<kendo-dialog title="Confirmation" [width]="300" *ngIf="opened" (close)="onClose()">
  <p>{{message}}</p>
    <button kendoButton style="width:45%;margin-right:5%" (click)="onCancel()">Cancel</button>
    <button kendoButton style="width:45%" (click)="onConfirm()">OK</button>
</kendo-dialog>
